document.addEventListener('DOMContentLoaded', function () {
  // ---- Abrir modal ----
  document.querySelectorAll('.js-open-scratch-modal').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var modal = document.getElementById(btn.dataset.target);
      if (modal) openScratchModal(modal);
    });
  });

  document.querySelectorAll('[data-scratch-modal]').forEach(function (modal) {
    modal.querySelectorAll('[data-scratch-close]').forEach(function (el) {
      el.addEventListener('click', function () { modal.classList.remove('is-open'); });
    });
    setupScratchModal(modal);
  });

  function openScratchModal(modal) {
    modal.classList.add('is-open');
    if (modal._scratchApi) modal._scratchApi.onOpen();
  }

  function setupScratchModal(modal) {
    var storageKey = modal.dataset.storageKey || 'scratch_revealed_v1';
    var card = modal.querySelector('[data-scratch-card]');
    var canvas = modal.querySelector('[data-scratch-canvas]');
    var hint = modal.querySelector('[data-scratch-hint]');
    var redeemBtn = modal.querySelector('[data-scratch-redeem]');
    var intro = modal.querySelector('[data-scratch-intro]');
    var defaultIntro = intro ? intro.textContent : '';

    var isScratched = false;
    try { isScratched = window.localStorage.getItem(storageKey) === 'true'; } catch (e) {}

    var ctx = null;
    var canvasInitialized = false;
    var isPointerDown = false;
    var moveCount = 0;

    function showRedeemed() {
      card.classList.add('is-cleared');
      if (hint) hint.style.display = 'none';
      if (redeemBtn) redeemBtn.style.display = 'flex';
      if (intro) intro.textContent = 'Que bom te ver de volta! Seu cupom já está liberado — é só resgatar.';
    }

    function setupCanvas() {
      var rect = card.getBoundingClientRect();
      canvas.width = rect.width;
      canvas.height = rect.height;
      ctx = canvas.getContext('2d');
      ctx.fillStyle = '#D6D1C1';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.globalCompositeOperation = 'destination-out';
    }

    function scratchAt(x, y) {
      if (!ctx) return;
      ctx.beginPath();
      ctx.arc(x, y, 22, 0, Math.PI * 2);
      ctx.fill();
    }

    function getPos(e) {
      var rect = canvas.getBoundingClientRect();
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      var clientY = e.touches ? e.touches[0].clientY : e.clientY;
      return { x: clientX - rect.left, y: clientY - rect.top };
    }

    function handleStart(e) {
      if (isScratched) return;
      isPointerDown = true;
      var p = getPos(e);
      scratchAt(p.x, p.y);
    }
    function handleMove(e) {
      if (!isPointerDown || isScratched) return;
      if (e.cancelable) e.preventDefault();
      var p = getPos(e);
      scratchAt(p.x, p.y);
      moveCount++;
      if (moveCount % 5 === 0) checkProgress();
    }
    function handleEnd() { isPointerDown = false; }

    function checkProgress() {
      if (!ctx || isScratched) return;
      var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
      var cleared = 0, sampled = 0;
      for (var i = 3; i < data.length; i += 4 * 15) {
        sampled++;
        if (data[i] === 0) cleared++;
      }
      if (sampled > 0 && cleared / sampled > 0.5) revealPrize();
    }

    function revealPrize() {
      if (isScratched) return;
      isScratched = true;
      try { window.localStorage.setItem(storageKey, 'true'); } catch (e) {}
      card.classList.add('is-cleared');
      if (hint) hint.style.display = 'none';
      if (redeemBtn) redeemBtn.style.display = 'flex';
    }

    canvas.addEventListener('mousedown', handleStart);
    canvas.addEventListener('mousemove', handleMove);
    window.addEventListener('mouseup', handleEnd);
    canvas.addEventListener('touchstart', handleStart, { passive: true });
    canvas.addEventListener('touchmove', handleMove, { passive: false });
    canvas.addEventListener('touchend', handleEnd);

    modal._scratchApi = {
      onOpen: function () {
        if (isScratched) {
          showRedeemed();
        } else if (!canvasInitialized) {
          canvasInitialized = true;
          setTimeout(setupCanvas, 60);
        }
      }
    };
  }
});
